import { dataLayerV2UniversalPush } from '../utils/tagManager'

const analytics = (typeTaggeo) => {
  let type = typeTaggeo
  let eventCategory = ''
  switch (typeTaggeo) {
  case ('Single_Liquidez') : {
    type = 'Simulador_PagLiquidezOferta'
    eventCategory = 'Lp_Mkt_Liquidez'
    break
  }
  default: {
    break
  }
  }
  dataLayerV2UniversalPush({
    'eventCategory': eventCategory,
    'eventAction': 'Button_Click',
    'eventLabel': type,
    'event': 'universalEvent'
  })
}

export default analytics
